export enum QUERY_PARAMS {
    fpActionToken = 'fpActionToken',
    redirectFromTabs = 'redirectFromTabs',
    preSelectUpgradeQuery = 'pre_select_upgrade',
    afterLoginUrl = 'afterLoginUrl',
    category = 'category',
    showHiddenGames = 'showHiddenGames',
    buyaPowaReferFriendMetaData = 'bp_e'
}
